import type { MappedLocation, RouteState } from 'shared';

const cityIata = (iata: string) => iata.slice(0, 3);

const segmentEndpointCode = (
  location: MappedLocation | undefined,
): string | null => {
  if (!location?.code) {
    return null;
  }
  return cityIata(
    ('codeForBackend' in location && location.codeForBackend) || location.code,
  );
};

/**
 * Two segments stored as separate routes (multi-trip UI) that are a classic
 * round-trip: first leg A→B, second leg B→A. Same pairing rule as
 * `saveLastSearchFromDict` / hash round-trip detection.
 */
export const isRoundTripAsTwoStoredLegs = (routes: RouteState[]): boolean => {
  if (routes.length !== 2) {
    return false;
  }
  const [outboundLeg, returnLeg] = routes;
  if (
    !outboundLeg?.dep ||
    !outboundLeg?.arr ||
    !returnLeg?.dep ||
    !returnLeg?.arr
  ) {
    return false;
  }
  const first = {
    dep: segmentEndpointCode(outboundLeg.dep),
    arr: segmentEndpointCode(outboundLeg.arr),
  };
  const second = {
    dep: segmentEndpointCode(returnLeg.dep),
    arr: segmentEndpointCode(returnLeg.arr),
  };
  if (!first.dep || !first.arr || !second.dep || !second.arr) {
    return false;
  }
  return first.dep === second.arr && first.arr === second.dep;
};
